import React from 'react'

export default function Form(props) {
    const { children, ...rest } = props;
    return (
        <form {...rest} autoComplete="false">
            {children}
        </form>
    )
}
